import React from 'react';
// import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
import { Form, Field, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { selectMobileNumberSkipVerifyErrorMessage } from '../../../selectors';
import StepContainer from '../steps/StepContainer';
import CompositeAlert from '../../core/CompositeAlert';
import Fieldset from '../../core/Fieldset';
import styles from '../mobileverification/mobileverificationstyles';
import FormikPhoneNumberField from '../../core/formik/FormikPhoneNumberField';
import {
  mobileValidationSchemaWithOptional,
  mobileValidationSchemaWithMandatory,
} from '../../core/mobileNumberValidationSchema';
// eslint-disable-next-line import/no-cycle
import { saveMobileNumberAndGoToNextStep, updateErrorMessage } from './actions';
// eslint-disable-next-line import/no-cycle
import { registerAccount } from '../idverification/actions';
import { useIsMobileOptional } from './customHooks';

const MobileNumberSkipVerify = () => {
  const dispatch = useDispatch();
  const errorMessage = useSelector(selectMobileNumberSkipVerifyErrorMessage);
  const isMobileOptional = useIsMobileOptional();

  const handleMobileNumberKeyPress = (e) => {
    const { which, keyCode, target } = e;
    const { value } = target;
    const charCode = which || keyCode;
    const char = String.fromCharCode(charCode);
    if (char === '0' && !value) {
      e.preventDefault();
    }
  };

  const handleSubmit = (values, { setSubmitting }) => {
    dispatch(saveMobileNumberAndGoToNextStep(values.mobileNumber)).then((result) => {
      if (result && result.shouldInvokeRegisterNext) {
        const stepLink = result.links && result.links.find((link) => link.rel === 'Register');
        if (stepLink) {
          const callback = () => {
            setSubmitting(false);
          };
          const errorCallback = null;
          dispatch(registerAccount(updateErrorMessage, stepLink.href, callback, errorCallback));
        } else {
          setSubmitting(false);
        }
      } else {
        setSubmitting(false);
      }
    });
  };

  const isSubmitDisabled = (isSubmitting, dirty, Object, errors) =>
    isSubmitting || (!isMobileOptional && !dirty) || Object.keys(errors).length > 0;

  return (
    <Formik
      initialValues={{
        mobileNumber: '',
      }}
      validateOnBlur={false}
      onSubmit={(values, formikActions) => {
        handleSubmit(values, formikActions);
      }}
      validationSchema={
        isMobileOptional ? mobileValidationSchemaWithOptional : mobileValidationSchemaWithMandatory
      }
    >
      {({ values, submitForm, isSubmitting, dirty, errors }) => (
        <StepContainer
          title="Verify your mobile number"
          subtitle="What is your mobile number?"
          submitLabel={isMobileOptional && !values.mobileNumber ? 'Register' : 'Continue'}
          isSubmitVisible
          isSubmitDisabled={isSubmitDisabled(isSubmitting, dirty, Object, errors)}
          onSubmit={submitForm}
        >
          <Form autoComplete="off" data-testid="mobileNumberForm">
            <Fieldset disabled={isSubmitting}>
              <Grid container spacing={2}>
                {errorMessage && (
                  <Grid item xs={12}>
                    <CompositeAlert variant="error" message={errorMessage} />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <Field
                    name="mobileNumber"
                    component={FormikPhoneNumberField}
                    onKeyPress={handleMobileNumberKeyPress}
                    pattern="^4[0-9]{2} [0-9]{3} [0-9]{3}|^04[0-9]{2} [0-9]{3} [0-9]{3}"
                    format="### ### ###"
                    value={values.mobileNumber}
                    autoFocus
                    showNoError
                    data-testid="mobileNumber"
                  />
                </Grid>
              </Grid>
            </Fieldset>
          </Form>
        </StepContainer>
      )}
    </Formik>
  );
};

export default withStyles(styles)(MobileNumberSkipVerify);
